import * as React from 'react'
import {LoadingSpinnerContainer} from '../../webui/progress/LoadingSpinnerContainer'
import {BoxBatteryReadings} from '../battery-status/BoxBatteryReadings'
import {useBatteryReadingsByBoxId} from '../battery-status/gql/useBatteryReadingsByBoxId'

interface Props {
  boxId: string
}

export const BoxPageBatteryReadings: React.FC<Props> = ({boxId}) => {
  const {data, loading, error} = useBatteryReadingsByBoxId({
    variables: {id: boxId},
  })

  if (loading) return <LoadingSpinnerContainer />

  // The hook returns BatteryReading[] directly
  const readings = data ?? []

  if (error && readings.length === 0) {
    return <div style={{padding: 8}}>Couldn’t load battery readings: {error.message}</div>
  }

  return <BoxBatteryReadings readings={readings} showTable={true} />
}
